import React from 'react'
import i18n from 'constants/strings'
import FilterDropdown from './FilterDropdown'
import { TimePeriodOption } from 'types/global'

export const ALL_TIME = 'ALL_TIME'

export interface DateItem {
  label: string
  ms: number | typeof ALL_TIME
}
interface Props {
  months?: number[]
  allTime?: boolean
  onSelect?: (item: DateItem) => any
  selectedMs?: number | typeof ALL_TIME
}

export const createDateFilterOptions = (
  months: number[] | undefined,
  allTime: boolean | undefined
): TimePeriodOption[] => {
  const MONTH = 2628000000
  const opts: TimePeriodOption[] = []

  if (allTime) {
    opts.push({ label: i18n.t('strDateFilter.allTime'), key: null })
  }

  if (months) {
    months.forEach(m =>
      opts.push({ label: i18n.t('strDateFilter.nMonths', { months: m }), key: m * MONTH })
    )
  }
  return opts
}

const DateFilterBar: React.FC<Props> = ({ months, allTime, onSelect, selectedMs }) => {
  return (
    <FilterDropdown
      options={createDateFilterOptions(months, allTime)}
      selectedKey={selectedMs}
      onSelect={opt => {
        //onSelect && onSelect({ ...opt, ms: opt.key })
      }}
    />
  )
}

export default DateFilterBar
